import { auth } from '../lib/supabase'

// Supabase Auth API - replaces the old authAPI
export const supabaseAuthAPI = {
  // Login with email and password
  login: async (email, password) => {
    try {
      const { data, error } = await auth.signIn(email, password)
      
      if (error) {
        throw new Error(error.message)
      }

      // Store the session token for backend API calls if needed
      if (data.session) {
        localStorage.setItem('supabase_token', data.session.access_token)
        localStorage.setItem('user', JSON.stringify(data.user))
      }

      return {
        data: {
          user: data.user,
          token: data.session?.access_token
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Register new user
  register: async (userData) => {
    try {
      const { email, password, ...profileData } = userData
      
      const { data, error } = await auth.signUp(email, password, profileData)
      
      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          user: data.user,
          message: 'Registration successful! Please check your email to verify your account.'
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Verify current session
  verifyToken: async () => {
    try {
      const { data, error } = await auth.getCurrentUser()
      
      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          user: data.user,
          valid: !!data.user
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Get user profile
  getProfile: async () => {
    try {
      const { data, error } = await auth.getCurrentUser()
      
      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          user: data.user
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Update user profile
  updateProfile: async (updates) => {
    try {
      const { data, error } = await auth.updateProfile(updates)
      
      if (error) {
        throw new Error(error.message)
      }

      // Update local storage
      localStorage.setItem('user', JSON.stringify(data.user))

      return {
        data: {
          user: data.user
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Logout
  logout: async () => {
    try {
      const { error } = await auth.signOut()
      
      if (error) {
        throw new Error(error.message)
      }

      // Clear local storage
      localStorage.removeItem('supabase_token')
      localStorage.removeItem('user')
      localStorage.removeItem('token') // Remove old token if exists

      return { data: { message: 'Logged out successfully' } }
    } catch (error) {
      throw error
    }
  },

  // Reset password
  resetPassword: async (email) => {
    try {
      const { data, error } = await auth.resetPassword(email)
      
      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          message: 'Password reset email sent! Please check your inbox.'
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Confirm password reset by updating password after recovery link
  resetPasswordConfirm: async (password) => {
    try {
      const { data, error } = await auth.updatePassword(password)

      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          message: 'Your password has been updated successfully.'
        }
      }
    } catch (error) {
      throw error
    }
  },

  // Get current session
  getCurrentSession: async () => {
    try {
      const { data, error } = await auth.getCurrentSession()
      
      if (error) {
        throw new Error(error.message)
      }

      return {
        data: {
          session: data.session,
          user: data.session?.user
        }
      }
    } catch (error) {
      throw error
    }
  }
}

export default supabaseAuthAPI